import { render, staticRenderFns } from "./StudentAbsenceNumberOfDaysReport.vue?vue&type=template&id=0b284acd&"
import script from "./StudentAbsenceNumberOfDaysReport.vue?vue&type=script&lang=js&"
export * from "./StudentAbsenceNumberOfDaysReport.vue?vue&type=script&lang=js&"
import style0 from "./StudentAbsenceNumberOfDaysReport.vue?vue&type=style&index=0&id=0b284acd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports